module.exports = __webpack_public_path__ + "static/media/11_digginglight.26bc63c7.jpg";